// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2EYc3","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__4NXrb"};